import React from 'react';

const DeptPE = () => {
  return (
    <div>
      DeptPE
      DeptPE
    </div>
  );
}

export default DeptPE;
